define(['jquery'], function banner($) {

    var bind;

    bind = function bind(banner, params) {
        params = new Object(params);

        var $banner= $(banner);
        var $slides = $banner.find('> ul > li');
        var slide = -1;
        var pause = params.pause || 1000;
        var pausedByHover = false;
        var auto;

        var change = function change() {
            slide++;
            if (slide >= $slides.length) {
                slide = 0;
            }
            $slides.eq(n).addClass('active').siblings().removeClass('active');
            $banner.trigger('banner.onChange');
        };

        var start = function start() {
            stop();
            auto = window.setInterval(changeSlide, pause);
        };

        var stop = function stop() {
            if(auto) {
                window.clearInterval(auto);
            }
        };

        var onMouseEnter = function onMouseEnter() {
            pausedByHover = true;
            stop();
        };

        var onMouseLeave = function onMouseLeave() {
            if(pausedByHover) {
                pausedByHover = false;
                start();
            }
        };

        $banner.on('mouseenter', onMouseEnter);
        $banner.on('mouseleave', onMouseLeave);

        $banner.on('banner.change', change);
        $banner.on('banner.start', start);
        $banner.on('banner.stop', stop);

        change();
        start();
    };

    return {
        bind: bind
    }
});